import type { JSX } from "react";

import { StandardComponents } from "@4pace-cpq/core";
import {
  VMItemGroups,
  VMLineItems,
  VMOpportunities,
  VMProducts,
  VMQuotes,
  VMSubItems,
} from "@4pace-cpq/core/api";

import { iframeId } from "@/Router";

type CloneRowMenuItemProps = {
  item:
    | VMOpportunities
    | VMQuotes
    | VMItemGroups
    | VMLineItems
    | VMSubItems
    | VMProducts;
  onSuccess?: () => void;
};

export function DeleteItemIconButtonWrapper(
  props: CloneRowMenuItemProps,
): JSX.Element {
  const postMessage = {
    iframeId: iframeId,
    eventName: "updateCart",
  };

  function onSuccess(): void {
    window.parent.postMessage(postMessage, "*");
  }

  return (
    <StandardComponents.DeleteItemIconButton
      item={props.item}
      onSuccess={onSuccess}
    />
  );
}
